module.exports = {"530926100":"耿马镇","530926101":"勐永镇","530926102":"勐撒镇","530926103":"孟定镇","530926200":"大兴乡","530926201":"芒洪拉祜族布朗族乡","530926202":"四排山乡","530926203":"贺派乡","530926204":"勐简乡","530926401":"耿马华侨农场","530926402":"勐撒农场","530926403":"孟定农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530926.json
// module id = 2747
// module chunks = 0